import React from 'react';
import '../styles/ArticleCard.css';

function ArticleCard({ article }) {
  const { image, category, title, excerpt, date, readTime, link, featured } = article;
  
  return (
    <article className={`article-card ${featured ? 'featured' : ''}`}>
      <div className="article-image">
        <img src={image} alt={title} />
        <span className="article-category">{category}</span>
      </div>
      <div className="article-content">
        <p className="article-title">{title}</p>
        <p className="article-excerpt">{excerpt}</p>
        <a href={link} className="read-more">Read Article <i className="fas fa-arrow-right"></i></a>
      </div>
    </article>
  );
}

export default ArticleCard;
